import { EnvironmentContext } from "components/Environment/EnvironmentContext";
import Box from "ds/components/Box";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";

import { showEnvVariableFormDrawer } from "../../EnvVariablesDrawer/EnvVariablesFormDrawer";
import { showDeleteConfirmation } from "../../VariableDeleteConfirmation/VariableDeleteConfirmation";
import { VariableCellComponentProps } from "./types";

const EnvVariableActionsCell = ({ variable, context }: VariableCellComponentProps) => {
  const { onDelete, onUpdate, canDeleteVariables, canCreateAndEditVariables } =
    useTypedContext(EnvironmentContext);
  const canBeEdited = !(variable.runtime || context);

  const hasEditAction =
    canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasOverrideAction =
    !canBeEdited && (canCreateAndEditVariables.result || !!canCreateAndEditVariables.message);
  const hasDeleteAction =
    canBeEdited && (canDeleteVariables.result || !!canDeleteVariables.message);

  // Return null if no actions are available
  if (!hasEditAction && !hasOverrideAction && !hasDeleteAction) {
    return null;
  }

  return (
    <Box>
      <DropdownMenuEllipsis tooltip="Environment variable actions">
        {hasEditAction && (
          <DropdownMenuItem
            isDisabled={!canCreateAndEditVariables.result}
            tooltip={canCreateAndEditVariables.message}
            onAction={() =>
              showEnvVariableFormDrawer({ id: variable.id, variable, onSubmit: onUpdate })
            }
          >
            Edit variable
          </DropdownMenuItem>
        )}
        {hasOverrideAction && (
          <DropdownMenuItem
            isDisabled={!canCreateAndEditVariables.result}
            tooltip={canCreateAndEditVariables.message}
            onAction={() =>
              showEnvVariableFormDrawer({ id: variable.id, variable, onSubmit: onUpdate })
            }
          >
            Override
          </DropdownMenuItem>
        )}
        {hasDeleteAction && (
          <DropdownMenuItem
            isDisabled={!canDeleteVariables.result}
            tooltip={canDeleteVariables.message}
            onAction={() => showDeleteConfirmation({ id: variable.id, onDelete })}
            danger
          >
            Delete
          </DropdownMenuItem>
        )}
      </DropdownMenuEllipsis>
    </Box>
  );
};

export default EnvVariableActionsCell;
